export function formatValue(value: string): number {
    return parseInt(value) || 0;
}
